<template>
    <div class="col-lg-4 mt-4">
        <div class="product">
            <figure>
                <img :src="product.image_url"
                     :alt="product.name"
                >

                <BadgeHolder v-if="product.badges.length > 0"
                             :badges="product.badges"
                             :discount_price="product.discount_price"
                             :main_price="product.main_price"
                             :default_price="product.default_price"
                             :stock="product.available"
                             :has_variations="product.has_variations"
                             :variation_values="product.variation_values">
                </BadgeHolder>

                <div class="hover">
                   <AddToWishlist
                        v-if="addToWishlistBtnText"
                        :product-id="product.id"
                        :btn-text="addToWishlistBtnText"
                        :with-modal="true"
                        :favourite-prop="product.favourite"
                    />
                    <a :href="product.detail_url" class="button outlined w-100">
                        Zobraziť detail
                    </a>
                </div>
            </figure>
            <h3>{{ product.name }}</h3>
            <p class="price">{{ product.main_price }}</p>
        </div>
    </div>
</template>

<!--<div class="card border-primary">-->
<!--<div class="card-header text-center">-->
<!--    <a :href="product.detail_url">-->
<!--        <h3>{{ product.name }}</h3>-->
<!--    </a>-->
<!--</div>-->
<!--<div class="card-body">-->
<!--    <div class="image">-->
<!--        <img :src="product.image_url"-->
<!--             :alt="product.name">-->
<!--    </div>-->
<!--    <p v-html="product.description"></p>-->

<!--    <AddToWishlist-->
<!--        v-if="addToWishlistBtnText"-->
<!--        :product-id="product.id"-->
<!--        :btn-text="addToWishlistBtnText"-->
<!--        :with-modal="true"-->
<!--    />-->

<!--    <RemoveFromWishlist-->
<!--        v-if="removeFromWishlistBtnText"-->
<!--        :product-id="product.id"-->
<!--        :btn-text="removeFromWishlistBtnText"-->
<!--        :with-modal="true"-->
<!--        @on-product-deleted="afterProductDeleted($event)"-->
<!--    />-->

<!--    <div>{{ product.main_price }} €</div>-->

<!--    <AddToCart :product-id="product.id"-->
<!--               :btn-text="addToCartBtnText"-->
<!--    />-->

<!--    <span class="meta-info">-->
<!--                     <a :href="product.detail_url">-->
<!--                        Viac info-->
<!--                    </a>-->
<!--                </span>-->
<!--</div>-->
<!--</div>-->

<script>
import {inject, onMounted, reactive, toRefs} from 'vue'

import AddToWishlist from '../../buttons/AddToWishlist'
import AddToCart from '../../buttons/AddToCart'
import RemoveFromWishlist from '../../buttons/RemoveFromWishlist'
import BadgeHolder from "./BadgeHolder";

export default {

    props: [
        'product',
        'addToCartBtnText',
        'addToWishlistBtnText',
        'removeFromWishlistBtnText'
    ],

    components: {
        BadgeHolder,
        AddToWishlist,
        AddToCart,
        RemoveFromWishlist
    },

    setup(props) {

        onMounted(() => {
            console.log(props.product)
        })

        function afterProductDeleted(id) {
            console.log('after product deleted:', id)
        }

        return {
            afterProductDeleted
        }
    }
}
</script>
